<template>
    <div>
        <div class="vx-row">
            <vx-card title="Add TID" class="mb-4 pb-5">
                <!-- location id -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Device</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required v-model="selected_device" :options="device_list" name="Device"
                            placeholder="Please Select Device" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Device')">{{
                            errors.first('Device')
                        }}
                        </span>

                    </div>
                </div>

                <!-- PTO Merchant -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Payment Channel</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <v-select required id="Payment Channel" v-model="selected_payment_channel"
                            placeholder="Please Select Payment Channel" name="Payment Channel"
                            :options="payment_channel_list" v-validate="'required'">
                        </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('Payment Channel')">{{
                            errors.first('Payment Channel')
                        }}</span>
                    </div>
                </div>

                <!-- MID Input -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>TID</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <vs-input class="w-full" v-model.trim="tid" placeholder="Please Fill TID Code"
                            v-validate="{ required: true, regex: /^[a-zA-Z0-9]{8}$/ }" name="TID Code"
                            @input="(val) => (tid = tid.toUpperCase())" />
                        <span class="text-danger text-sm" v-show="errors.has('TID Code')">{{
                            errors.first('TID Code')
                        }}</span>
                    </div>
                </div>

                <!-- Is Active -->
                <div class="w-full flex flex-no-wrap">
                    <div class="w-1/6 p-5">
                        <span>Is Activated</span>
                    </div>
                    <div class="w-5/6 p-4">
                        <input type="radio" value=true v-model="isActive"> Yes
                        <input type="radio" value=false v-model="isActive"> No
                    </div>
                </div>

                <!-- action button -->
                <div class="w-full text-right  p-4">
                    <vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
                    <vs-button id="btn-submit" class="ml-4" @click.prevent="showConfirmDialog">Submit</vs-button>
                    <vs-popup title="Are you sure with this data?" :active.sync="popupActivo">
                        Before <br />
                        Device Code : <b>{{ this.$route.params.currentTID.mdrd_code }}</b><br />
                        Device Serial Number : <b>{{ this.$route.params.currentTID.mdrd_serial_number }}</b><br />
                        Payment Channel Code : <b>{{
                            this.$route.params.currentTID.payment_channel_code
                        }}</b><br />
                        Payment Channel Name : <b>{{
                            this.$route.params.currentTID.payment_channel_name
                        }}</b><br />
                        TID Code : <b>{{ this.$route.params.currentTID.tid_code }}</b><br />
                        Is Active : <b>{{ this.$route.params.currentTID.is_active }}</b><br />
                        <br />
                        After <br />
                        Device Code : <b>{{ this.selected_device.device_code }}</b><br />
                        Device Serial Number : <b>{{ this.selected_device.serial_number }}</b><br />
                        Payment Channel Code : <b>{{ this.selected_payment_channel.payment_code }}</b><br />
                        Payment Channel Name : <b>{{ this.selected_payment_channel.label }}</b><br />
                        TID Code : <b>{{ this.tid }}</b><br />
                        Is Active : <b>{{ this.isActive }}</b><br />
                        <div class="w-full text-right">
                            <vs-button id="btn-submit" class="mt-5 ml-4" @click.prevent="submitForm">Submit</vs-button>
                        </div>
                    </vs-popup>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import AxiosCall from "@/global/AxiosCall";
import { url } from "@/configs/apiUrl";
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'
import swal from "sweetalert2";

export default {
    name: "EditTid",
    components: {
        'v-select': vSelect,
        VueSimpleSuggest
    },
    data() {
        return {
            device_list: [],
            selected_device: [],
            payment_channel_list: [],
            selected_payment_channel: [],
            tid: '',
            isActive: '',
            popupActivo: false,
        }
    },
    watch: {

    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        // begin 
        backPage() {
            this.$router.push({ name: 'TIDAndMIDManagement' })
        },
        showConfirmDialog() {
            this.$validator.validateAll()
                .then((res) => {
                    if (res) {
                        this.popupActivo = true;
                    }
                })
        },
        submitForm() {
            this.$validator.validateAll()
                .then((res) => {
                    this.popupActivo = false;
                    if (res) {
                        let payload = {
                            mdr_id: this.selected_device.mdr_id,
                            mdrd_id: this.selected_device.mdrd_id,
                            mdrd_code: this.selected_device.device_code,
                            mdrd_serial_number: this.selected_device.serial_number,
                            payment_channel_id: this.selected_payment_channel.payment_id,
                            payment_channel_code: this.selected_payment_channel.payment_code,
                            payment_channel_name: this.selected_payment_channel.label,
                            tid_code: this.tid,
                            is_active: this.isActive
                        }
                        AxiosCall.Put(url.svd.tid.update + this.$route.params.id, payload)
                            .then((res) => {
                                if (res.message_code === 'E_INVALID_PARAMETER') {
                                    swal.fire({
                                        type: 'warning',
                                        title: 'Warning',
                                        text: res.message,
                                        allowOutsideClick: false,
                                    })
                                } else if (res.message_code === '2003') {
                                    let status = true
                                    this.$router.push({ name: "TIDAndMIDManagement", params: { status: status, message: " Succes Update TID Data " } })
                                }
                            }, (error) => {
                                swal.fire({
                                    type: 'warning',
                                    title: 'Warning',
                                    text: error.response.data.message,
                                    allowOutsideClick: false,
                                })
                            })
                    }
                })
        }
    },
    mounted() {
        if (this.$route.params.id === undefined) {
            location.href = "/tid-and-mid-management"
        } else {
            this.selected_device = {
                label: this.$route.params.currentTID.mdrd_code,
                device_code: this.$route.params.currentTID.mdrd_code,
                mdr_id: this.$route.params.currentTID.mdr_id,
                mdrd_id: this.$route.params.currentTID.mdrd_id,
                serial_number: this.$route.params.currentTID.mdrd_serial_number,
            }
            this.selected_payment_channel = {
                label: this.$route.params.currentTID.payment_channel_name,
                payment_code: this.$route.params.currentTID.payment_channel_code,
                payment_id: this.$route.params.currentTID.payment_channel_id
            }

            this.tid = this.$route.params.currentTID.tid_code
            this.isActive = this.$route.params.currentTID.is_active

        }

        // get device list
        AxiosCall.Get(url.svd.device.combo).then(resp => {
            for (let data of resp.data) {
                this.device_list.push({
                    label: data.name + "  |  " + data.code,
                    mdrd_id: data.id,
                    mdr_id: data.mdr_id,
                    device_code: data.code,
                    device_name: data.name,
                    device_type: data.device_type,
                    serial_number: data.device_serial_number,
                    merchant: data.merchant_full_name
                })
            }
        })

        // get payment channel list
        AxiosCall.Get(url.svd.payment_channel.combo).then(resp => {
            for (let data of resp.data) {
                this.payment_channel_list.push({
                    label: data.name,
                    payment_code: data.code,
                    payment_id: data.id
                })
            }
        })
    }
}
</script>

<style>
.con-vs-popup .vs-popup {
    width: auto !important;
    height: auto !important;
}
</style>
